export interface LimitChangesSummary {
  period: string;
  type: string;
  action: string;
  author: string;
  timestamp: Date;
  from: string;
  to: string;
  limitType: LimitType;
}

export interface LimitsUpdateSummary {
  daily?: LimitsPeriodUpdateSummary;
  weekly?: LimitsPeriodUpdateSummary;
  monthly?: LimitsPeriodUpdateSummary;
}

export interface LimitsPeriodUpdateSummary {
  limitBefore?: string;
  limitAfter?: string;
  maxBefore?: string;
  maxAfter?: string;
  pendingBefore?: string;
  pendingAfter?: string;
}

export interface UpdateLimits {
  daily?: string;
  weekly?: string;
  monthly?: string;
}

export interface Limits {
  daily?: Limit;
  weekly?: Limit;
  monthly?: Limit;
}

export interface Limit {
  limit?: string;
  max?: string;
  current?: string;
  pending?: PendingLimit;
  resetDate?: Date;
}

export interface PendingLimit {
  amount: string;
  confirmation: Date;
}

export enum LimitType {
  NET_LOSS = 'NET_LOSS',
  DEPOSIT = 'DEPOSIT',
}

export const limitTypeToLabel: Record<LimitType, string> = {
  [LimitType.NET_LOSS]: 'Net loss',
  [LimitType.DEPOSIT]: 'Deposit',
};

export const limitTypeToDataId: Record<LimitType, string> = {
  [LimitType.NET_LOSS]: 'Netloss',
  [LimitType.DEPOSIT]: 'Deposit',
};
